import { type FC, useEffect } from "react";
import { ShiftHistoryContent } from "@/components/ShiftHistory/ShiftHistoryContent";
import { useAnalytics } from "@/contexts/analytics/hooks";
import type { NurseInShift } from "@/utils/models";
import { GapsStaffStep } from "./gapsSheetTypes";

type Props = {
	nurseInShift: NurseInShift;
	name: string;
	onStep: (step: GapsStaffStep) => void;
	onClose: () => void;
};

/** The phone's staff sheet has no recurring shift editor to open. */
const NO_RECURRING_EDITOR_ON_PHONE = undefined;

/** The phone reader fills the viewport, with its own fixed viewed-shift heading. */
export const GapsStaffHistoryStep: FC<Props> = ({ nurseInShift, name, onStep, onClose }) => {
	const { track } = useAnalytics();
	useEffect(() => {
		track("shift_history_opened", { shift_id: nurseInShift.id, surface: "gaps_staff_sheet" });
	}, [nurseInShift.id, track]);
	return (
		<ShiftHistoryContent
			key={nurseInShift.id}
			nurseInShift={nurseInShift}
			nurseName={name}
			onClose={onClose}
			onBackToSchedule={() => onStep(GapsStaffStep.More)}
			onEditRecurring={NO_RECURRING_EDITOR_ON_PHONE}
		/>
	);
};
